import { Component } from '@angular/core';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-accessibility-statement',
	templateUrl: './accessibility-statement.page.html',
	styleUrls: ['./accessibility-statement.page.scss'],
})
export class BarrierefreiheitPage {
	static url = 'barrierefreiheit';

	constructor(
		private repository: RepositoryService,
		private navigationService: NavigationService,
		private location: Location,
		public translate: TranslateService
	) {}

	async goBack() {
		if (this.location) {
			this.location.back();
			return;
		}

		if (!this.repository._order) {
			await this.navigationService.home();
		} else {
			await this.navigationService.menu();
		}
	}
}
